<rk-modal-wrapper
  [dialogRef]="dialogRef"
  [title]="'MEDIA.MODAL.BAC.DELETE.TITLE' | translate"
  [submitText]="'MEDIA.MODAL.BAC.DELETE.ACTION_BUTTON' | translate"
>
  <div
    class="head-delete-bac-modal"
    [innerHTML]="
      'MEDIA.MODAL.BAC.DELETE.MAIN' | translate: { name: bac.translated$ | async }
    "
  ></div>
  <div
    class="body-delete-bac-modal"
    [innerHTML]="'MEDIA.MODAL.BAC.DELETE.TRACKS' | translate: { tracks: bac?.count }"
  ></div>
</rk-modal-wrapper>
